import React from 'react'
import ContentLoader, { Rect } from 'react-content-loader/native'
import { white } from '@qirapagos/lib/theme/colors'

const InvestmentsSkeleton = () => (
  <ContentLoader
    speed={2.5}
    interval={0}
    width="100%"
    height="100vh"
    viewBox="0 0 100% 100vh"
    backgroundColor="#e8e7f7"
    foregroundColor={white}
  >
    <Rect x="3%" y="4vh" rx="10" ry="10" width="44%" height="22%" />

    <Rect x="53%" y="4vh" rx="10" ry="10" width="44%" height="22%" />

    <Rect x="2%" y="30vh" rx="8" ry="8" width="96%" height="65%" />
  </ContentLoader>
)

export default InvestmentsSkeleton
